export default __webpack_public_path__ + "static/char-s-58-ko-a1ff3094b19d37fbe37e789bbe4652ae.png";